import React, {useContext, useEffect, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink, BlobProvider} from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';

const IcpdfDetalleEmpresa = () => {
  
    const { datoIC } = useContext(UserContext);
    

    
  moment.locale('spanish');
  const FechaImpresion = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01
  


    const IdentificacionEmpresa = (

        <View style={{ fontSize: 9 }}>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Rut:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.Identificacion?.Rut}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Rubro:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.DetalleIdentificacionEmpresa?.Rubro}</Text>
            </View>

            {datoIC.DetalleIdentificacionEmpresa?.NombreFantasia != null ?
                <View style={{ flexDirection: 'row', fontSize: 9 }}>
                    <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Nombre Fantasía:</Text>
                    <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.DetalleIdentificacionEmpresa?.NombreFantasia}</Text>
                </View>
                : ''}


            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Disolución Vigente:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.Resumenes?.DisolucionVigente?.DisolicionVigente}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Fecha Disolución:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.Resumenes?.DisolucionVigente?.FechaDisolucion}</Text>
            </View>

            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Teléfono uno (1):</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.Identificacion?.IsEmpresa ? datoIC.DetalleIdentificacionEmpresa?.CodigoArea + '-' + datoIC.DetalleIdentificacionEmpresa?.Telefono : datoIC.DetalleIdentificacion?.CodigoArea + '-' + datoIC.DetalleIdentificacion?.Telefono}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Teléfono dos (2):</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.Identificacion?.IsEmpresa ? datoIC.DetalleIdentificacionEmpresa?.CodigoArea2 + '-' + datoIC.DetalleIdentificacionEmpresa?.Telefono2 : datoIC.DetalleIdentificacion?.CodigoArea2 + '-' + datoIC.DetalleIdentificacion?.Telefono2}</Text>
            </View>

            {datoIC.DetalleIdentificacionEmpresa?.Direccion != null ?
                <View style={{ flexDirection: 'row', fontSize: 9 }}>
                    <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Dirección Registrada:</Text>
                    <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.DetalleIdentificacionEmpresa?.Direccion}</Text>
                </View>
                : ''}


        </View>
    );

    const TblIconoEmpresa = (
        <>
            <View style={{ flexDirection: 'row', height: '80px', textAlign: 'center' }}>

                {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre == 'MICRO' ?
                    <View style={{ color: 'black', padding: '2,15', width: '140px', height: '70px', border: '1 solid #e6e6e6' }}>
                        <Text style={{ padding: '2,10', fontSize: 9, textAlign: 'center' }}>MICRO EMPRESA</Text>
                        <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/MicroEmpresaChekList.jpg'} style={{ width: '80%', textAlign: 'center', padding: '5,10' }} fixed />


                    </View>
                    :
                    <View style={{ color: 'black', padding: '2,15', width: '140px', height: '70px', border: '1 solid #e6e6e6' }}>
                        <Text style={{ padding: '2,10', fontSize: 9, textAlign: 'center' }}>MICRO EMPRESA</Text>
                        <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/MicroEmpresa.jpg'} style={{ width: '60%', textAlign: 'center', padding: '5,10' }} fixed />


                    </View>}


                {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre == 'PEQUEÑA' ?
                    <View style={{ color: 'black', padding: '2,15', width: '145px', height: '70px', border: '1 solid #e6e6e6' }}>
                        <Text style={{ padding: '2,10', fontSize: 9, textAlign: 'center' }}>PEQUEÑA EMPRESA</Text>
                        <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/EmpresaPequenaChekList.jpg'} style={{ width: '90%', textAlign: 'center', padding: '5,10' }} fixed />


                    </View>
                    :
                    <View style={{ color: 'black', padding: '2,15', width: '145px', height: '70px', border: '1 solid #e6e6e6' }}>
                        <Text style={{ padding: '2,10', fontSize: 9, textAlign: 'center' }}>PEQUEÑA EMPRESA</Text>
                        <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/EmpresaPequena.jpg'} style={{ width: '60%', textAlign: 'center', padding: '5,10' }} fixed />


                    </View>}


                {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre == 'MEDIANA' ?
                    <View style={{ color: 'black', padding: '2,15', width: '140px', height: '70px', border: '1 solid #e6e6e6' }}>
                        <Text style={{ padding: '2,10', fontSize: 9, textAlign: 'center' }}>MEDIANA EMPRESA</Text>
                        <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/EmpresaMedianaChekList.jpg'} style={{ width: '90%', textAlign: 'center', padding: '5,10' }} fixed />


                    </View>
                    :
                    <View style={{ color: 'black', padding: '2,15', width: '140px', height: '70px', border: '1 solid #e6e6e6' }}>
                        <Text style={{ padding: '2,10', fontSize: 9, textAlign: 'center' }}>MEDIANA EMPRESA</Text>
                        <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/EmpresaMediana.jpg'} style={{ width: '60%', textAlign: 'center', padding: '5,10' }} fixed />


                    </View>}


                {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Nombre == 'GRANDE' ?
                    <View style={{ color: 'black', padding: '2,15', width: '142px', height: '70px', border: '1 solid #e6e6e6' }}>
                        <Text style={{ padding: '2,10', fontSize: 9, textAlign: 'center' }}>GRANDE EMPRESA</Text>
                        <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/EmpresaGrandeChekList.jpg'} style={{ width: '90%', textAlign: 'center', padding: '5,10' }} fixed />



                    </View>
                    :
                    <View style={{ color: 'black', padding: '2,15', width: '142px', height: '70px', border: '1 solid #e6e6e6' }}>
                        <Text style={{ padding: '2,10', fontSize: 9, textAlign: 'center' }}>GRANDE EMPRESA</Text>
                        <Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/EmpresaGrande.jpg'} style={{ width: '60%', textAlign: 'center', padding: '5,10' }} fixed />



                    </View>}

            </View>

        </>
    );
    

    const TableDetalleEmpresa = (
        <>
            {datoIC.DetalleIdentificacionEmpresa != null ?
                <View style={{ fontSize: 9, }}>

                    <View style={{ flexDirection: 'row', fontSize: 9 }}>
                        <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Tipo de Contribuyente::</Text>
                        <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.DetalleIdentificacionEmpresa.DatosExtras?.TipoContribuyente}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', fontSize: 9 }}>
                        <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Sub Tipo de Contribuyente:</Text>
                        <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.DetalleIdentificacionEmpresa.DatosExtras?.SubTipoContribuyente}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', fontSize: 9 }}>
                        <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Rubro:</Text>
                        <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Rubro}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', fontSize: 9 }}>
                        <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Sub Rubro:</Text>
                        <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.DetalleIdentificacionEmpresa.DatosExtras?.SubRubro}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', fontSize: 9 }}>
                        <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Actividad:</Text>
                        <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Actividad}</Text>
                    </View>

                </View>
                : 'SIN INFORMACIÓN EMPRESA'}
        </>
    );


    const TableIndicadorEmpresa =(
        <>
        <View style={{ flexDirection: 'row' }}>
    

        <View style={{ color: 'black', padding: '2,15', width: '200px', border: '1 solid #e6e6e6' }}>

            <Text style={{ padding: '2,15', fontSize: 9, textAlign: 'center', borderBottom: '1 solid #e6e6e6', fontWeight: 'bold' }}>TAMAÑO EMPRESA:</Text>
            <Text style={{ padding: '1,10', fontSize: 11, textAlign: 'center' }}> {datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Descripcion != null || datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Descripcion != undefined ? datoIC.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Descripcion : 'SIN INFORMACIÓN EMPRESA'}</Text>

        </View>
        </View>
        </>
    );


   
    const ReporteDetalleEmpresa =()=>(
         
        <Document >
            
            <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }}>
                <View>


                    <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />
                  
                    <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: {FechaImpresion}</Text>
                    <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />
                   
                    <View fixed>
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}  >{datoIC.Identificacion?.IsEmpresa ? datoIC.DetalleIdentificacionEmpresa?.Nombre : datoIC.Identificacion?.Nombre} RUT {datoIC.Identificacion?.Rut}</Text>
                    </View>

                    <View style={{ width: '100%' }}>
                       
                        {IdentificacionEmpresa}
                        
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}></Text>
                        {TableDetalleEmpresa}
                    </View>
                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}></Text>
                        {TableIndicadorEmpresa}
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}></Text>
                        {TblIconoEmpresa}
                    </View>

                    <View style={{ width: '50%', alignContent: 'left' }}>
                    {/*<Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} />*/}
                    <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}  >Nro. FOLIO: {datoIC.ID} - {uuid(datoIC.ID)}</Text>
                    </View>


                </View>


            </Page>

        </Document>

    ); 



    
    
    return useMemo(
        ()=>(
        <div>

        
        <PDFDownloadLink  document={<ReporteDetalleEmpresa />} fileName={`${uuid()}.pdf`}>

        {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR ARCHIVO PDF</h2>)}
          
        </PDFDownloadLink>
            
           

        </div>
    ),[]
    
);
}

export default IcpdfDetalleEmpresa
